import { PreviewProps } from '../../preview/preview';

export function getSortedDefaultLayers(
  defaultLayers: Record<string, PreviewProps>,
  product: string,
): Map<string, PreviewProps> {
  const previewImageOrder = getProductPreviewsOrder(product);

  // Order defaultLayers according to the order array if it exists, otherwise keep original order
  const defaultLayersEntries = Object.entries(defaultLayers);

  const sortedEntries = previewImageOrder
    ? defaultLayersEntries.sort(([keyA], [keyB]) => {
        const indexA = previewImageOrder.indexOf(Number(keyA));
        const indexB = previewImageOrder.indexOf(Number(keyB));

        // If both keys are in the order array, sort by their position in the array
        if (indexA !== -1 && indexB !== -1) {
          return indexA - indexB;
        }
        // If only keyA is in the order array, it comes first
        if (indexA !== -1) {
          return -1;
        }
        // If only keyB is in the order array, it comes first
        if (indexB !== -1) {
          return 1;
        }
        // If neither is in the order array, maintain original order
        return 0;
      })
    : defaultLayersEntries;

  return new Map<string, PreviewProps>(sortedEntries);
}

function getProductPreviewsOrder(product: string): number[] | undefined {
  if (product === 'Suit') {
    return [9, 5, 3];
  } else if (product === 'Tuxedo') {
    return [7, 2, 8];
  }
  return undefined;
}

export function getLcpLayer(
  defaultLayers: Record<string, PreviewProps>,
  product: string,
): { src: string; srcset: string; sizes: string } | null {
  const sorted = getSortedDefaultLayers(defaultLayers, product);
  const first = sorted.values().next().value;
  const layer = first?.layers?.[0];
  if (!layer?.src) return null;
  return { src: layer.src, srcset: layer.srcset, sizes: layer.sizes };
}
